import { render } from "./SocialMediaShareButtons.vue?vue&type=template&id=5851655e&scoped=true"
import script from "./SocialMediaShareButtons.vue?vue&type=script&lang=js"
export * from "./SocialMediaShareButtons.vue?vue&type=script&lang=js"

import "./SocialMediaShareButtons.vue?vue&type=style&index=0&id=5851655e&scoped=true&lang=css"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5851655e"]])

export default __exports__